/** Normalize CRA env strings (strip wrapping quotes / whitespace). */
export function normalizeEnvUrl(raw) {
  if (typeof raw !== 'string') return undefined;
  const s = raw.replace(/^["']|["']$/g, '').trim();
  return s.length > 0 ? s : undefined;
}

/** Arcscan public mainnet RPC (chain 5042) — verified eth_chainId 0x13b2. */
const ARC_MAINNET_PUBLIC_RPC = 'https://rpc.arc-scan.org';
const ARC_TESTNET_PUBLIC_RPC = 'https://rpc.testnet.arc.network';

/**
 * Ordered JSON-RPC URLs for Arc: primary first, then fallbacks.
 * Supports:
 *   REACT_APP_RPC_URL
 *   REACT_APP_RPC_FALLBACK_URL
 *   REACT_APP_RPC_FALLBACK_URL_2
 *   REACT_APP_RPC_URLS (comma-separated extras)
 *
 * Public Arc RPC is appended last based on REACT_APP_CHAIN_ID
 * (mainnet 5042 vs testnet 5042002) — never mixes chains.
 */
export function buildRpcHttpUrls() {
  const ordered = [];
  const push = (url) => {
    if (url && !ordered.includes(url)) ordered.push(url);
  };

  push(normalizeEnvUrl(process.env.REACT_APP_RPC_URL));
  push(normalizeEnvUrl(process.env.REACT_APP_RPC_FALLBACK_URL));
  push(normalizeEnvUrl(process.env.REACT_APP_RPC_FALLBACK_URL_2));

  const extrasRaw = process.env.REACT_APP_RPC_URLS;
  if (typeof extrasRaw === 'string' && extrasRaw.trim()) {
    extrasRaw
      .split(',')
      .map((part) => normalizeEnvUrl(part))
      .forEach(push);
  }

  const chainId = Number(process.env.REACT_APP_CHAIN_ID);
  if (chainId === 5042) {
    push(ARC_MAINNET_PUBLIC_RPC);
  } else if (chainId === 5042002) {
    push(ARC_TESTNET_PUBLIC_RPC);
  }

  return ordered;
}

export const rpcHttpUrls = buildRpcHttpUrls();
export const primaryRpcUrl = rpcHttpUrls[0];
